


























































// Vue
import Vue, { PropType } from "vue";
// Models
import { JobModel, JobImageModel } from "@/core/api/apiClient";

export default Vue.extend({
  name: "ImagesDialog",
  props: {
    isViewing: Boolean,
    job: Object as PropType<JobModel>
  },

  data() {
    return {
      dialog: false,

      images: [] as JobImageModel[]
    };
  },

  methods: {
    initialize(): void {
      if (!this.job.jobImages) return;
      this.images = this.job.jobImages;
    },

    close(): void {
      this.images = [] as JobImageModel[];
      this.dialog = false;
    }
  }
});
